module.exports = __webpack_public_path__ + "fonts/StyreneAWeb-ThinItalic.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/StyreneAWeb-ThinItalic.woff
// module id = 72
// module chunks = 8